'use client';

import { DataList, DataListRow } from '@tranquility-ai/theme-components/data-list';
import type { MobileUiConfigResponse } from '@/shared/mobile-service/api/cors-mobile-api';
import { queryCitationSummaries } from '@/shared/mobile-service/lib/citation-table';
import type { MobileEvidence } from '@/shared/types';

/**
 * Investigator-facing summaries of the queries behind a mobile analysis answer.
 *
 * Each block is the agent's own label plus the filters and shape that produced
 * the cited rows. Artifact citations are omitted; those are rows, not queries.
 */
export function QuerySummaries({
  sources,
  uiConfig,
}: {
  sources: Array<{ evidence?: MobileEvidence | null }> | undefined;
  /** Magnet citations use the artifact title from this config as the query name. */
  uiConfig?: MobileUiConfigResponse;
}) {
  const groups = queryCitationSummaries(sources, uiConfig);
  if (groups.length === 0) return null;
  return (
    <div data-testid="MobileQuerySummaries" className="mt-3 flex max-w-[800px] flex-col gap-2">
      <DataList>
        {groups.map((lines) => (
          <DataListRow
            key={lines.join('\n')}
            title={lines[0] ?? 'Query'}
            description={lines.slice(1).join(' · ')}
          />
        ))}
      </DataList>
    </div>
  );
}
